module.exports = __webpack_public_path__ + "static/media/Update-light.42e7a695.svg";